import { gql } from '@apollo/client';

export default gql`
  mutation uploadPlaceFile($placeId: ID!, $file: Upload!) {
    uploadPlaceFile(input: { placeId: $placeId, file: $file }) {
      externalFile {
        id
        filename
        contentType
        fileSize
        externalUrl
        isImage
        isPdf
        fileExtension
      }
    }
  }
`;
